var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container-sitc" }, [
    _c("div", { staticClass: "filter-container-content" }, [
      _c(
        "div",
        { staticStyle: { padding: "0 40px" } },
        [
          _c("span", { staticClass: "title-h4" }, [
            _vm._v(_vm._s(_vm.$t("vesselMovement.title"))),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "search-form",
              attrs: {
                model: _vm.voyageRateForm,
                "label-position": "top",
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("vesselMovement.vesselName"),
                            prop: "vesselCode",
                          },
                        },
                        [
                          _c("glVesselMain", {
                            attrs: {
                              displayCode: false,
                              displayInit: _vm.voyageRateForm.vesselName,
                            },
                            on: { change: _vm.vesselChange },
                            model: {
                              value: _vm.voyageRateForm.vesselCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.voyageRateForm, "vesselCode", $$v)
                              },
                              expression: "voyageRateForm.vesselCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-primary",
                          staticStyle: { "margin-top": "30px" },
                          attrs: { type: "primary" },
                          on: { click: _vm.search },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("button.search")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.isResult
      ? _c(
          "div",
          { staticClass: "result-container" },
          [
            _c("h4", [_vm._v(_vm._s(_vm.$t("vesselMovement.tips_1")))]),
            _vm._v(" "),
            _c("div", { staticClass: "warm-tips" }, [
              _c("span", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v(_vm._s(_vm.$t("vesselMovement.tips_2"))),
              ]),
              _vm._v(_vm._s(_vm.$t("vesselMovement.tips_3")) + " "),
              _c("span", { staticStyle: { color: "blue" } }, [
                _vm._v(_vm._s(_vm.$t("vesselMovement.tips_4"))),
              ]),
              _vm._v(_vm._s(_vm.$t("vesselMovement.tips_5")) + "\n      "),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v(_vm._s(_vm.$t("vesselMovement.tips_6"))),
              ]),
              _vm._v("\n      " + _vm._s(_vm.$t("vesselMovement.tips_7"))),
              _c("br"),
              _vm._v("\n      " + _vm._s(_vm.$t("vesselMovement.tips_8"))),
              _c("br"),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: "http://www.toyoshingo.com/sitc/",
                    target: "_blank",
                  },
                },
                [_vm._v("URL: http://www.toyoshingo.com/sitc/")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.movementInfo,
                  stripe: "",
                  border: "",
                  size: "mini",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "vesselName",
                    label: _vm.$t("vesselMovement.vesselNameShort"),
                    "min-width": "8%",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "voyageNo",
                    label: _vm.$t("vesselMovement.voyage"),
                    "min-width": "8%",
                    "show-overflow-tooltip": "true",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "portName",
                    label: _vm.$t("vesselMovement.port"),
                    "min-width": "8%",
                    "show-overflow-tooltip": "true",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "terminalCode",
                    label: _vm.$t("vesselMovement.terminal"),
                    "min-width": "20%",
                  },
                }),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  {
                    attrs: {
                      prop: "eta",
                      label: _vm.$t("vesselMovement.originalETA"),
                      "min-width": "7%",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "ccta",
                        label: _vm.$t("vesselMovement.eta"),
                        "min-width": "7%",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      props.row.eta !== ""
                                        ? _vm.dateFormat("MM-DD", props.row.eta)
                                        : ""
                                    ) +
                                    " \n            "
                                ),
                                _c(
                                  "span",
                                  { staticStyle: { color: "#00CD00" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        new Date(props.row.eta).getDay() ===
                                          0 ||
                                          new Date(props.row.eta).getDay() === 6
                                          ? _vm.weekFormatter(props.row.eta)
                                          : ""
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      new Date(props.row.eta).getDay() !== 0 &&
                                        new Date(props.row.eta).getDay() !== 6
                                        ? _vm.weekFormatter(props.row.eta)
                                        : ""
                                    ) +
                                    "\n            "
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("div", {
                                  staticStyle: {
                                    border: "0px",
                                    "border-bottom": "1px dashed",
                                  },
                                }),
                                _vm._v(" "),
                                !_vm.validateNull(props.row.ata)
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.dateFormat(
                                              "MM-DD hh:mm",
                                              props.row.ata
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : !_vm.validateNull(props.row.agta)
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "blue" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.dateFormat(
                                              "MM-DD hh:mm",
                                              props.row.agta
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : !_vm.validateNull(props.row.cta)
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateFormat(
                                            "MM-DD hh:mm",
                                            props.row.cta
                                          )
                                        )
                                      ),
                                    ])
                                  : !_vm.validateNull(props.row.ccta)
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateFormat(
                                            "MM-DD hh:mm",
                                            props.row.ccta
                                          )
                                        )
                                      ),
                                    ])
                                  : _c("span", [_vm._v(_vm._s(" "))]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1365424892
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  {
                    attrs: {
                      prop: "etb",
                      label: _vm.$t("vesselMovement.originalETB"),
                      "min-width": "7%",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "cctb",
                        label: _vm.$t("vesselMovement.etb"),
                        "min-width": "7%",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      props.row.etb !== ""
                                        ? _vm.dateFormat("MM-DD", props.row.etb)
                                        : ""
                                    ) +
                                    " \n            "
                                ),
                                _c(
                                  "span",
                                  { staticStyle: { color: "#00CD00" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        new Date(props.row.etb).getDay() ===
                                          0 ||
                                          new Date(props.row.etb).getDay() === 6
                                          ? _vm.weekFormatter(props.row.etb)
                                          : ""
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      new Date(props.row.etb).getDay() !== 0 &&
                                        new Date(props.row.etb).getDay() !== 6
                                        ? _vm.weekFormatter(props.row.etb)
                                        : ""
                                    ) +
                                    "\n            "
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("div", {
                                  staticStyle: {
                                    border: "0px",
                                    "border-bottom": "1px dashed",
                                  },
                                }),
                                _vm._v(" "),
                                !_vm.validateNull(props.row.atb)
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.dateFormat(
                                              "MM-DD hh:mm",
                                              props.row.atb
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : !_vm.validateNull(props.row.agtb)
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "blue" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.dateFormat(
                                              "MM-DD hh:mm",
                                              props.row.agtb
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : !_vm.validateNull(props.row.ctb)
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateFormat(
                                            "MM-DD hh:mm",
                                            props.row.ctb
                                          )
                                        )
                                      ),
                                    ])
                                  : !_vm.validateNull(props.row.cctb)
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateFormat(
                                            "MM-DD hh:mm",
                                            props.row.cctb
                                          )
                                        )
                                      ),
                                    ])
                                  : _c("span", [_vm._v(_vm._s(" "))]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3476225788
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  {
                    attrs: {
                      prop: "etd",
                      label: _vm.$t("vesselMovement.originalETD"),
                      "min-width": "7%",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "cctd",
                        label: _vm.$t("vesselMovement.etd"),
                        "min-width": "7%",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      props.row.etd !== ""
                                        ? _vm.dateFormat("MM-DD", props.row.etd)
                                        : ""
                                    ) +
                                    " \n            "
                                ),
                                _c(
                                  "span",
                                  { staticStyle: { color: "#00CD00" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        new Date(props.row.etd).getDay() ===
                                          0 ||
                                          new Date(props.row.etd).getDay() === 6
                                          ? _vm.weekFormatter(props.row.etd)
                                          : ""
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      new Date(props.row.etd).getDay() !== 0 &&
                                        new Date(props.row.etd).getDay() !== 6
                                        ? _vm.weekFormatter(props.row.etd)
                                        : ""
                                    ) +
                                    "\n            "
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("div", {
                                  staticStyle: {
                                    border: "0px",
                                    "border-bottom": "1px dashed",
                                  },
                                }),
                                _vm._v(" "),
                                !_vm.validateNull(props.row.atd)
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.dateFormat(
                                              "MM-DD hh:mm",
                                              props.row.atd
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : !_vm.validateNull(props.row.agtd)
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "blue" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.dateFormat(
                                              "MM-DD hh:mm",
                                              props.row.agtd
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : !_vm.validateNull(props.row.ctd)
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateFormat(
                                            "MM-DD hh:mm",
                                            props.row.ctd
                                          )
                                        )
                                      ),
                                    ])
                                  : !_vm.validateNull(props.row.cctd)
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateFormat(
                                            "MM-DD hh:mm",
                                            props.row.cctd
                                          )
                                        )
                                      ),
                                    ])
                                  : _c("span", [_vm._v(_vm._s(" "))]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3657929852
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "rate",
                    label: _vm.$t("vesselMovement.rate"),
                    "min-width": "7%",
                    "show-overflow-tooltip": "true",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (prop) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  prop.row.rate === null
                                    ? ""
                                    : prop.row.rate.split("(")[0]
                                ) +
                                "\n          "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  prop.row.rate === null
                                    ? ""
                                    : "(" +
                                        _vm.getShortTime(
                                          prop.row.rate.match(/\(([^)]*)\)/)[1]
                                        ) +
                                        ")"
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2898788160
                  ),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "remark",
                    label: _vm.$t("vesselMovement.remark"),
                    "min-width": "8%",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "updatedDtmLoc",
                    label: _vm.$t("vesselMovement.updateTime"),
                    "min-width": "7%",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.getExactTime(props.row.updatedDtmLoc)
                                ) +
                                " \n        "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3601708924
                  ),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "center",
                  "font-size": "16px",
                  color: "#0086cb",
                  "padding-bottom": "20px",
                  "padding-top": "10px",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: { click: _vm.lastMonth },
                  },
                  [_vm._v(_vm._s(_vm.$t("vesselMovement.lastMonth")))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: { click: _vm.nextMonth },
                  },
                  [_vm._v(_vm._s(_vm.$t("vesselMovement.nextMonth")))]
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }